module.exports = __webpack_public_path__ + "4eeb865b3df80a43383331ae79965db6.MP3";